import { EnvironmentInjector, Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { Firestore } from '@angular/fire/firestore';
import { create, toJson } from '@bufbuild/protobuf';
import {
  CollectionNames,
  ProjectJobServiceCreateResponseJson,
  ProjectJobServiceCreateResponseSchema,
  ProjectJobServiceListRequestSchema,
  defaultApiSerializeJsonOptions,
} from '@vmspdb/definitions';
import { AuthRunEffects } from '@vmspdb/ui/store';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import {
  ProjectJobRepositoryService,
  withSearchSync,
} from '../../repositories';
import * as ProjectJobsActions from './project-jobs.actions';

@Injectable()
export class ProjectJobsEffects extends AuthRunEffects {
  private firestore = inject(Firestore);
  private injector = inject(EnvironmentInjector);
  private repository = inject(ProjectJobRepositoryService);

  loadProjectJobs$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ProjectJobsActions.loadProjectJobs),
      withSearchSync(CollectionNames.ProjectJobs, this.injector),
      switchMap(({ projectUuid }) =>
        this.repository.list(
          create(ProjectJobServiceListRequestSchema, { projectUuid }),
        ),
      ),
      switchMap((result) =>
        of(
          ProjectJobsActions.setProjectJobs({
            projectJobs: (result.items ?? []).map(
              (item) =>
                toJson(
                  ProjectJobServiceCreateResponseSchema,
                  item,
                  defaultApiSerializeJsonOptions,
                ) as ProjectJobServiceCreateResponseJson,
            ),
          }),
        ),
      ),
    );
  });

  constructor() {
    const actions$ = inject(Actions);

    super(actions$);
  }
}
